/* Этот файл сгенерирован автоматически на основe шаблона exportService.hbs */
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountSettingsDto } from '../models';
import type { AppearanceSettingsRequest } from '../models';
import type { MessagePreviewSettingsRequest } from '../models';
import type { NonContactPreviewSettingsRequest } from '../models';
import type { NonContactRestrictionsRequest } from '../models';
import type { QuickReactionSettingsRequest } from '../models';
import type { ShowForwardedNameRequest } from '../models';
import type { UpdateUnreadMessagesModeRequest } from '../models';
import type { UpdateUserPrivacyRequest } from '../models';
import type { UpdateUserVideoNoteMessageModeRequest } from '../models';
import type { UpdateUserVoiceMessageModeRequest } from '../models';
import type { VcsAccessRequestsNotificationsRequest } from '../models';
import type { VcsAccessRequestsSoundRequest } from '../models';
import type { WorkspaceActionRequest } from '../models';
import { request } from 'api/apiRouter';
import type { ApiRequestOptions, ApiResponse } from '@web-chat-core/toolkit/src/api3';
export class AccountSettingsControllerService {
    public static getSettings(
        requestBody?: any,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<AccountSettingsDto>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings',
            body: requestBody,
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateVoiceMessageMode(
        requestBody: UpdateUserVoiceMessageModeRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/voice-message-mode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateVideoNoteMessageMode(
        requestBody: UpdateUserVideoNoteMessageModeRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/video-note-message-mode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateUserPrivacy(
        requestBody: UpdateUserPrivacyRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/user-privacy',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateVcsAccessRequestsSound(
        requestBody: VcsAccessRequestsSoundRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/update-vcs-access-requests-sound',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateVcsAccessRequestsSoundOAuth(
        requestBody: VcsAccessRequestsSoundRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/update-vcs-access-requests-soundOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateVcsAccessRequestsNotifications(
        requestBody: VcsAccessRequestsNotificationsRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/update-vcs-access-requests-notifications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateVcsAccessRequestsNotificationsOAuth(
        requestBody: VcsAccessRequestsNotificationsRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/update-vcs-access-requests-notificationsOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateUnreadMessagesMode(
        requestBody: UpdateUnreadMessagesModeRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/unread-messages-mode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateShowForwardedName(
        requestBody: ShowForwardedNameRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/show-forwarded-name',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static showWorkspace(
        requestBody: WorkspaceActionRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/show-active-workspace',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateQuickReaction(
        requestBody: QuickReactionSettingsRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/quick-reaction',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateNonContactRestrictions(
        requestBody: NonContactRestrictionsRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/non-contact-restrictions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateNonContactPreview(
        requestBody: NonContactPreviewSettingsRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/non-contact-preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateMessagePreview(
        requestBody: MessagePreviewSettingsRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/message-preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static hideWorkspace(
        requestBody: WorkspaceActionRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/hide-active-workspace',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static updateAppearance(
        requestBody: AppearanceSettingsRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<void>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v1/account/settings/account-appearance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
}
